<template>
  <div class="col backgroundForm">
    <div class="form-row">
      <div class="form-group col col-md-6">
          <label for="date_init_discharge" class="badge badge-info">DEL:</label>         
          <input type="date" class="form-control" id="date_init_discharge" name="date_init_discharge" v-model="date_init" placeholder="DD/MM/YYYY" autocomplete="off">
      </div>
      <div class="form-group col col-md-6">
          <label for="date_end_discharge" class="badge badge-info">AL:</label>         
          <input type="date" class="form-control" id="date_end_discharge" name="date_end_discharge" v-model="date_end" placeholder="DD/MM/YYYY" autocomplete="off">
      </div>
    </div>
    <button class="btn btn-outline-primary col col-md-4 offset-md-4" @click="mGetDtsMatriz"><font-awesome-icon icon="table" /> Generar Tabla</button>
    <br><br>
        <div class="col-12 col-md-4 offset-md-8 d-print-none">
            
            <button class="btn btn-outline-primary" @click="mCopyToClipboard('printTable')">
                <font-awesome-icon icon="copy" /><br>copiar 
            </button>
        </div> 
    <div class="table-responsive d-print-block landscape" id="printTable" v-if="table_captains!==null">
      <h5 align="center"><b>Dirección General de Capitanías de Puerto</b><br>
      {{ date_init_aux }} al {{ date_end_aux }}</h5>
      
      <table class="table table-bordered table-hover" v-html="table_captains">

      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default {
  name:'table-resume-ccpp',
  data(){
    return{
      date_init:'',
      date_end:'',
      table_captains:null,
      captains:[],
      operaciones:[],
      matren:[],
      sanciones:[],
      pasavante:[],
      date_init_aux:null,
      date_end_aux:null
    }
  },
  mounted(){
    this.getToday();
  },
  methods:{
    mCopyToClipboard(elemento) {
      var $temp = $("<input>")
      $("body").append($temp);
      // console.log($(`#${elemento}`));
      $temp.val($(`#${elemento}`).html()).select();
      document.execCommand("copy");
      $temp.remove();
      toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
    },
    getToday(){
      let  today = new Date();
      let m = today.getMonth() + 1;
      let mes = (m < 10) ? '0' + m : m;
      let d = today.getDate();
      let dia= (d < 10) ? '0'+d : d;
      let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
      this.date_init=date_aux;
      this.date_end=date_aux;            
    },
    mValidateFechas(){
      if(this.date_init===''){
        toastr.warning('Fecha de Inicio', 'Seleccione la fecha de Inicio');
        return false;
      }
      if(this.date_end===''){
        toastr.warning('Fecha Final', 'Seleccione una fecha final o de Conclusión');
        return false;
      }
      if(this.date_end < this.date_init){
        toastr.warning('Error de Fechas', 'La fecha de Inicio NO puede ser mayor a la fecha final');
        return false;
      }
      return true;
    },
    async mGetDtsMatriz(){
      if(this.mValidateFechas()){
        this.date_init_aux=this.$dateWrite(this.date_init);
        this.date_end_aux=this.$dateWrite(this.date_end);
        // console.log('llamando al servidor para extraer el resumen de la informacion');
        let ccpp=await axios.get(`requestCapitan?api_token=${Vue.auth.getToken()}`);
        // console.log(ccpp);
        this.capitanias=ccpp.data;
        // obtenemos el resumen de operaciones realizadas en las fechas indicadas zarpe, atraque
        let opera=await axios.get(`getResumeOperaciones/${this.date_init}/${this.date_end}/oper?api_token=${Vue.auth.getToken()}`);
        // console.log(opera);
        this.operaciones=opera.data;
        let multas=await axios.get(`getResumeOperaciones/${this.date_init}/${this.date_end}/mul?api_token=${Vue.auth.getToken()}`);
        // console.log(multas);
        this.sanciones=multas.data;
        let renov=await axios.get(`getResumeOperaciones/${this.date_init}/${this.date_end}/matren?api_token=${Vue.auth.getToken()}`);
        // console.log(renov);
        this.matren=renov.data;
        let pasav=await axios.get(`getResumeOperaciones/${this.date_init}/${this.date_end}/pasav?api_token=${Vue.auth.getToken()}`);
        // console.log(pasav);
        this.pasavante=pasav.data;
        this.generateTable();
      }
    },
    generateTable(){
      this.table_captains='';
      let cabecera='';
      cabecera+=`<thead class="fijo"><tr><th>N°</th>
                 <th>Capitanía</th>
                 <th>Operaciones</th>
                 <th>Sanciones</th>
                 <th>Matriculación/Renovación</th>
                 <th>Pasavantes</th></tr></thead>`;
      this.table_captains+=cabecera;
      let fila='<tbody>';
      this.capitanias.forEach( (ccpp, index) => {
        fila=`<tr><td>${(index+1)}</td>
                  <td class="fijo2">${ccpp.name_port}</td>`;
          
          // registro de operaciones registradas en sistema
          let contOp=0;
          let auxText='';
          this.operaciones.forEach( (ope)=>{
            if(ope.port === ccpp.id_capitania ){
              contOp+=1;
              auxText+=`${ope.operation} - ${ope.total}<br>`;
            }
          })
          if(contOp>0){
            fila+=`<td>${auxText}</td>`;
          }else{
            fila+=`<td>Sin Registro</td>`;
          }
        
          let contSanciones=0;
          let auxSanciones='';
          this.sanciones.forEach( (sanc)=>{
            if(sanc.port === ccpp.id_capitania ){
              contSanciones+=1;
              auxSanciones+=`${sanc.operation} - ${sanc.total}<br>`;
            }
          })
          if(contSanciones>0){
            fila+=`<td>${auxSanciones}</td>`;
          }else{
            fila+=`<td>Sin Registro</td>`;
          }

          // matriculacion renovacion
          let contMatRen=0;
          let auxMatRen='';
          this.matren.forEach( (matr)=>{
            if(matr.port === ccpp.id_capitania ){
              contMatRen+=1;
              let auxT;
              if(matr.operation==='M'){
                auxT='MATRICULACIÓN'
              }else{
                auxT='RENOVACIÓN';
              }
              auxMatRen+=`${auxT} - ${matr.total}<br>`;
            }
          })
          if(contMatRen>0){
            fila+=`<td>${auxMatRen}</td>`;
          }else{
            fila+=`<td>Sin Registro</td>`;
          }
        let ixa=this.pasavante.findIndex( (pasv)=> pasv.port === ccpp.id_capitania);
        if(ixa !== -1){
          fila+=`<td>${this.pasavante[ixa].operation} - ${this.pasavante[ixa].total}</td>`;
        }else{
          fila+=`<td>Sin Registros</td>`;
        }
        fila+='</tr>';
        this.table_captains+=fila;
      });
      this.table_captains+='</tbody>';
    }
  }
}
</script>

<style>
.noline{
  white-space:nowrap;  
}

th{
  white-space:nowrap;
}

.table-responsive { 
            height:600px;
            overflow:scroll;
}
.fijo{
    position:sticky; 
    top:0; 
    z-index:10;
    background-color: white;
}
.fijo2{
    position:sticky; 
    left:0;
    top: 0;
    /* bottom: 0;  */
    z-index:9;
    background-color:white;
    /* border-left: solid 1px #ccc;
    border-right: solid 1px #ccc; */
}
.table tbody tr .fijo2{
    background-color:white !important;

} 
</style>


// WEBPACK FOOTER //
// src/components/captain/TableCaptainResume.vue